import { create } from 'zustand';

const initialPieceState = { id: '', name: '', code: '', barcode: '', brand: '', tempCode: '' };
const initialState = {
    pieces: [],
    directPieces: [],
    piece: initialPieceState,
    errors: {},
    isAdding: false,
    isEditing: false,
    isEditingRow: false,
    isDirectEditing: false,
    isLoading: false,
};

export const usePieceStore = create((set, get) => ({
    /* ---------------------- STATE ---------------------- */

    ...initialState,

    /* ---------------------- SETTERS ---------------------- */

    setIsEditingRow: (localId) => set({ isEditingRow: localId }),
    setIsAdding: (value) => set({ isAdding: value }),
    setIsEditing: (value) => set({ isEditing: value }),

    setEditPiece: (piece) => {
        set({
            piece: { ...piece },
            isEditing: true,
            isEditingRow: piece.localId,
            errors: {},
        });
    },

    setCancelEdit: () => {
        set({
            isEditing: false,
            errors: {},
        });
    },

    setDirectEditPiece: (state) =>
        set({
            piece: { ...state },
            isEditing: true,
            isDirectEditing: true,
            isEditingRow: state.localId,
            errors: {},
        }),

    setCode: (code) =>
        set((state) => ({
            piece: { ...state.piece, code },
        })),

    setTempCode: (tempCode) =>
        set((state) => ({
            piece: { ...state.piece, tempCode },
        })),

    setIsLoading: (value) =>
        set(() => ({
            isLoading: value,
        })),

    /* ---------------------- PIECE OPERATIONS ---------------------- */

    addPiece: (item) =>
        set((state) => ({
            piece: { ...state.piece, ...item },
            errors: {},
        })),

    savePiece: () =>
        set((state) => ({
            pieces: [...state.pieces, { ...state.piece }],
        })),

    updatePiece: (localId, updated) =>
        set((state) => ({
            piece: state.piece.localId === localId ? { ...state.piece, ...updated } : state.piece,
        })),

    saveUpdatedPiece: (localId, updated) =>
        set((state) => ({
            pieces: state.pieces.map((piece) => (piece.localId === localId ? { ...piece, ...updated } : piece)),
        })),

    saveDirectPiece: () =>
        set((state) => ({
            directPieces: [...state.directPieces, { ...state.piece }],
        })),

    deletePiece: (localId) =>
        set((state) => ({
            pieces: state.pieces.filter((b) => b.localId !== localId),
        })),

    /* ---------------------- VALIDATION ---------------------- */

    validatePiece: () =>
        set((state) => {
            const errors = {};
            const { name, code } = state.piece;

            if (!name.trim()) errors.name = 'Tambahkan minimal 1 produk untuk menyimpan mapping';
            if (!code.trim()) errors.code = 'Kode Product di Toko tidak boleh Kosong';

            return { errors };
        }),

    /* ---------------------- UTILS ---------------------- */

    hasUnsavedChanges: () => {
        const { piece } = get();
        const check = !!piece.code.trim() || !!piece.name.trim();

        return check;
    },

    /* ---------------------- RESETTERS ---------------------- */

    resetPiece: () =>
        set({
            piece: initialPieceState,
            isEditing: false,
            isEditingRow: false,
            errors: {},
        }),

    resetDirectPieces: () =>
        set({
            directPieces: [],
            isDirectEditing: false,
            piece: initialPieceState,
        }),

    resetPieces: () =>
        set({
            ...initialState,
        }),

    resetError: () =>
        set({
            errors: {},
        }),
}));
